const facilities = [
  {
    id: "col-usps-main",
    name: "Columbia Main Post Office",
    type: "USPS Passport Acceptance",
    address: "1601 Assembly Street",
    city: "Columbia",
    state: "SC",
    zip: "29201",
    phone: "800-275-8777",
    hours: "Mon–Fri 9am–5pm, Sat 9am–12pm",
    distance: "Downtown Columbia",
    website: "https://tools.usps.com/find-location.htm",
    websiteLabel: "Schedule Appointment",
    notes: "Appointment required. Confirm passport photo availability when booking.",
    icon: "ri-mail-line",
  },
  {
    id: "col-usps-lexington",
    name: "Lexington Post Office",
    type: "USPS Passport Acceptance",
    address: "5701 Sunset Blvd",
    city: "Lexington",
    state: "SC",
    zip: "29072",
    phone: "800-275-8777",
    hours: "Mon–Fri 9am–5pm",
    distance: "Lexington (~15 mi west of downtown)",
    website: "https://tools.usps.com/find-location.htm",
    websiteLabel: "Schedule Appointment",
    notes: "Convenient for Lexington and Irmo residents.",
    icon: "ri-mail-line",
  },
  {
    id: "col-usps-westcol",
    name: "West Columbia Post Office",
    type: "USPS Passport Acceptance",
    address: "310 Sunset Blvd",
    city: "West Columbia",
    state: "SC",
    zip: "29169",
    phone: "800-275-8777",
    hours: "Mon–Fri 9am–5pm",
    distance: "West Columbia (~3 mi west of downtown)",
    website: "https://tools.usps.com/find-location.htm",
    websiteLabel: "Schedule Appointment",
    notes: "Good option for Cayce, West Columbia, and Airport District residents.",
    icon: "ri-mail-line",
  },
  {
    id: "col-richland-clerk",
    name: "Richland County Probate Court",
    type: "County Clerk Passport Acceptance",
    address: "1701 Main Street",
    city: "Columbia",
    state: "SC",
    zip: "29201",
    phone: "803-576-1990",
    hours: "Mon–Fri 8:30am–5pm",
    distance: "Downtown Columbia",
    website: "https://www.richlandcountysc.gov/",
    websiteLabel: "Clerk Info",
    notes: "Richland County acceptance option. Confirm appointments before visiting.",
    icon: "ri-government-line",
  },
  {
    id: "col-usps-forest",
    name: "Forest Acres Post Office",
    type: "USPS Passport Acceptance",
    address: "4020 Trenholm Road",
    city: "Columbia",
    state: "SC",
    zip: "29206",
    phone: "800-275-8777",
    hours: "Mon–Fri 9am–5pm",
    distance: "Forest Acres (~4 mi east of downtown)",
    website: "https://tools.usps.com/find-location.htm",
    websiteLabel: "Schedule Appointment",
    notes: "Good option for Forest Acres and Northeast Columbia residents.",
    icon: "ri-mail-line",
  },
  {
    id: "col-usps-irmo",
    name: "Irmo Post Office",
    type: "USPS Passport Acceptance",
    address: "7403 Woodrow Street",
    city: "Irmo",
    state: "SC",
    zip: "29063",
    phone: "800-275-8777",
    hours: "Mon–Fri 9am–5pm",
    distance: "Irmo (~12 mi northwest of downtown)",
    website: "https://tools.usps.com/find-location.htm",
    websiteLabel: "Schedule Appointment",
    notes: "Convenient for Irmo, Lake Murray, and northwest Richland County residents.",
    icon: "ri-mail-line",
  },
];

export default function ColumbiaAcceptanceFacilitiesSection() {
  return (
    <section id="acceptance-facilities" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Passport Acceptance Clerks</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Passport Acceptance Facilities Near Columbia, SC
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed mb-6">
            First-time applicants and most applicants who are not eligible for a standard mail-in renewal must apply in person at a passport acceptance clerk. All locations require an appointment.
          </p>
          <div className="bg-amber-50 border border-amber-200 rounded-lg p-5 max-w-2xl mx-auto text-left">
            <div className="flex items-start gap-3">
              <div className="w-8 h-8 flex items-center justify-center rounded-full bg-amber-100 flex-shrink-0 mt-0.5">
                <i className="ri-error-warning-line text-amber-600 text-base"></i>
              </div>
              <p className="text-gray-700 text-sm leading-relaxed">
                If you want to use a registered U.S. Department of State courier to receive your passport in as little as 3 days, you must sign up with{" "}
                <a href="https://fastpassportcenter.com/checkout/" className="font-bold text-[#1A365D] underline underline-offset-2 hover:text-[#F6C344] transition-colors">Fast Passport Center</a>{" "}
                <strong>before</strong> going to the clerk. Once your documents go through the standard route, they cannot be upgraded to expedited courier service.
              </p>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-10">
          {facilities.map((f) => (
            <article key={f.id} className="bg-[#F7F8FA] border border-gray-200 rounded-lg p-6 flex flex-col hover:border-[#F6C344] transition-all duration-200">
              <div className="flex items-start gap-3 mb-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#1A365D] flex-shrink-0">
                  <i className={`${f.icon} text-[#F6C344] text-base`}></i>
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="font-bold text-[#1A365D] text-sm leading-snug mb-0.5">{f.name}</h3>
                  <span className="text-xs text-gray-400 font-medium">{f.type}</span>
                </div>
              </div>

              <div className="space-y-2 flex-1">
                <div className="flex items-start gap-2 text-sm text-gray-600">
                  <i className="ri-map-pin-line text-[#F6C344] flex-shrink-0 mt-0.5 text-base"></i>
                  <span>{f.address}, {f.city}, {f.state} {f.zip}</span>
                </div>
                <div className="flex items-center gap-2 text-sm text-gray-600">
                  <i className="ri-phone-line text-[#F6C344] flex-shrink-0 text-base"></i>
                  <a href={`tel:${f.phone.replace(/-/g, "")}`} className="hover:text-[#1A365D] transition-colors">{f.phone}</a>
                </div>
                <div className="flex items-start gap-2 text-sm text-gray-600">
                  <i className="ri-time-line text-[#F6C344] flex-shrink-0 mt-0.5 text-base"></i>
                  <span>{f.hours}</span>
                </div>
                <div className="flex items-center gap-2 text-sm text-gray-600">
                  <i className="ri-road-map-line text-[#F6C344] flex-shrink-0 text-base"></i>
                  <span>{f.distance}</span>
                </div>
                <div className="flex items-center gap-2 text-sm">
                  <i className="ri-global-line text-[#F6C344] flex-shrink-0 text-base"></i>
                  <a href={f.website} target="_blank" rel="nofollow noopener noreferrer" className="text-[#1A365D] font-medium hover:text-[#F6C344] transition-colors underline underline-offset-2">
                    {f.websiteLabel}
                  </a>
                </div>
              </div>

              <div className="mt-4 pt-4 border-t border-gray-200">
                <span className="inline-flex items-center gap-1 text-xs font-semibold bg-amber-50 text-amber-700 px-2 py-0.5 rounded-full whitespace-nowrap mb-2">
                  <i className="ri-calendar-line text-xs"></i> Appointment Required
                </span>
                <p className="text-xs text-gray-400 leading-relaxed italic">{f.notes}</p>
              </div>
            </article>
          ))}
        </div>

        <div className="bg-[#1A365D] rounded-lg p-4 flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-start gap-4">
            <div className="w-11 h-11 flex items-center justify-center rounded-full bg-[#F6C344] flex-shrink-0">
              <i className="ri-information-line text-[#1A365D] text-xl"></i>
            </div>
            <div>
              <p className="font-bold text-white text-base mb-1">Sign up before your clerk visit</p>
              <p className="text-white/70 text-sm leading-relaxed max-w-xl">
                If you need your expedited passport fast, sign up with Fast Passport Center <strong className="text-white">before</strong> your clerk appointment. Once your documents go through the standard route, there's no upgrading afterward.
              </p>
            </div>
          </div>
          <a href="https://fastpassportcenter.com/checkout/" className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-sm px-6 py-3 rounded-md transition-all whitespace-nowrap flex-shrink-0">
            Start My Expedited Passport <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}